function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
export {
  getDefaultExportFromCjs
};
//# sourceMappingURL=_commonjsHelpers.js.map
